import xmlHttpRequest from './xmlHttpRequest';

const resolveUrlParameters = (path, urlParams) => {
  if (!urlParams) {
    return path;
  }
  Object.keys(urlParams).forEach(urlParam => {
    path = path.replace(`:${urlParam}`, urlParams[urlParam]);
  });
  return path;
};

export function encodeQueryParams(obj, prefix) {
  const str = [];
  let p;
  for (p in obj) {
    if (obj.hasOwnProperty(p) && obj[p] !== undefined) {
      let k;
      if (Object.prototype.toString.call(obj) === '[object Array]') {
        k = prefix ? `${prefix}[]` : p;
      } else {
        k = prefix ? `${prefix}[${p}]` : p;
      }
      const v = obj[p];
      str.push(
        v !== null && typeof v === 'object'
          ? encodeQueryParams(v, k)
          : `${encodeURIComponent(k)}=${encodeURIComponent(v)}`
      );
    }
  }
  return str.join('&');
}

const getItemFromPersistentStore = (key, defaultValue) => {
  let value = localStorage.getItem(key);
  if (!value) {
    return defaultValue;
  }
  try {
    value = JSON.parse(value);
  } catch (error) {
    console.log('Error in parsing : ', error);
  }
  return value;
};

const DEFAULT_HOST = process.env.FRONTEND_SERVER_ADDRESS || '';

const request = async ({
  additionalParams = {},
  host = DEFAULT_HOST,
  urlParams,
  path,
  body,
  headers = {},
  queryParams = {},
  method = 'GET',
  isFile = false,
  isUploadToServer = false,
  onUploadProgress
}) => {

  let options = {
    method,

    headers: {
      ...headers
    },
    credentials: 'include'
  };
  if (!isFile) {
    options.headers['accept'] = 'application/json';
    options.headers['Content-Type'] = 'application/json';
  }
  if (getItemFromPersistentStore('loginType', '') === 'sso') {
    options.headers = { ...options.headers };
    options.headers.xsignintype = 'sso';
  }
  if (method !== 'GET' && body && !isFile) {
    options.body = JSON.stringify(body);
  }
  if (isFile) {
    options.body = body;
  }

  let url = host + resolveUrlParameters(path, urlParams) + `?${encodeQueryParams(queryParams)}`;

  if (isUploadToServer) {
    return xmlHttpRequest({
      method,
      host,
      body,
      headers,
      onUploadProgress
    });
  } else {
    let contentType;
    let statusCode;
    const errorMessages = additionalParams.errorMessages || {};

    return fetch(url, options)
      .then(response => {
        contentType = response.headers.get('content-type');
        statusCode = response.status;

        if (statusCode >= 500) {
          const error = new Error(errorMessages.internalServerErrorMessage);
          error.status = statusCode;
          throw error;
        }
        if (response.status === 204) {
          return {};
        }
        if (response.ok) {
          if (contentType && contentType.indexOf('application/json') === 0) {
            return response.json().catch(error => {
              // BFF send no response with statusCode 200. Handled that here.
              // TODO move this error tracking to sentry
              error.message = errorMessages.internalServerErrorMessage;
              throw error;
            });
          }
          // if (contentType && contentType.indexOf('text/html') === 0) return response.text();
          return response;
        }
        const error = new Error();
        error.response = response;
        error.status = statusCode;
        throw error;
      })
      .then(response => {
        // Some APIs are returning error messages with 200 status. :')
        if (response.constructor === {}.constructor && response.success === false) {
          const error = new Error();
          error.body = response;
          error.status = statusCode;
          throw error;
        }
        return response;
      })
      .catch(err => {
        const error = new Error();
        error.statusCode = err.status;
        error.message = err.message;
        error.body = err.body;
        if (error.statusCode >= 500) {
          error.message = errorMessages.internalServerErrorMessage;
          throw error;
        }
        if (error.message === 'Failed to fetch') {
          error.message = errorMessages.unableToConnectErrorMessage;
        }
        if (err.response) {
          if (contentType && contentType.indexOf('application/json') === 0) {
            return err.response
              .json()
              .then(errorBody => {
                error.body = errorBody;
                throw error;
              })
              .catch(() => {
                throw error;
              });
          }
          if (contentType && contentType.indexOf('text/html') === 0) {
            return err.response.text().then(text => {
              error.message = text;
              throw error;
            });
          }
        }
        throw error;
      });
  }
};

export default request;
